import React, { Component } from 'react';
import HeroLayout from '../Hero';
import { useStaticQuery, graphql } from 'gatsby';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css?family=Playfair+Display:400,700|Work+Sans:400,500,700&display=swap');
/*! minireset.css v0.0.5 | MIT License | github.com/jgthms/minireset.css */html,body,p,ol,ul,li,dl,dt,dd,blockquote,figure,fieldset,legend,textarea,pre,iframe,hr,h1,h2,h3,h4,h5,h6{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:normal}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}img,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}
html {
      font-family: 'Work Sans', sans-serif;
    }
    h1,
    h2,
    h3,
    h4 {
      font-family: 'Playfair Display', serif;
    }
`;

class ErrorBoundaryClass extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    if (typeof window !== 'undefined') {
      window.Sentry.configureScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
      });
      window.Sentry.captureException(error);
    }
  }

  render() {
    const { imageFluid } = this.props;
    if (this.state.error) {
      // render fallback UI
      return (
        <>
          <GlobalStyle />
          <HeroLayout
            // overflow="hidden"
            imageHeight="100vh"
            showArrow={false}
            button={{
              text: 'Go to the Homepage',
              to: '/',
              variant: 'white',
              mt: 3,
            }}
            title="Something's disconnected"
            description="We're sorry, something wrong happened."
            imageFluid={imageFluid}
          />
        </>
      );
    } else {
      // when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

const ErrorBoundary = props => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "404.png" }) {
        childImageSharp {
          fluid(maxWidth: 2000, toFormat: JPG) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <ErrorBoundaryClass
      imageFluid={data.file.childImageSharp.fluid}
      {...props}
    />
  );
};

export default ErrorBoundary;
